import { render, staticRenderFns } from "./GroupsController.vue?vue&type=template&id=ae46db64&scoped=true"
import script from "./GroupsController.vue?vue&type=script&lang=ts"
export * from "./GroupsController.vue?vue&type=script&lang=ts"
import style0 from "./GroupsController.vue?vue&type=style&index=0&id=ae46db64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae46db64",
  null
  
)

export default component.exports